import { State, Group } from '@/store/modules/apm/topoGroup/topoGroup.store';

const getters = {
  groups(state: State) {
    if(state.groups && state.groups.length) {
      return state.groups;
    }
    return [];
    // const index = state.groups.findIndex((i: Group) => i.id === state.groupId);
    // return state.groups[index].services;
  },
  groupServices(state: State) {
    if (!state.groups.length) {
      return [];
    }
    if (state.groupId === 'all') {
      return [];
    }
    const index = state.groups.findIndex((i: Group) => i.id === state.groupId);
    return state.groups[index]?.apps;
  }
};

export default getters;
